"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDesignToken = void 0;
const design_tokens_tokens_json_1 = __importDefault(require("../design-tokens.tokens.json"));
// Path is a dot separated token name
// E.g. colour.primary.green.50
// Fallback value (empty sring by default) will be returned if path does not exist
const getDesignToken = (path, fallbackValue = "") => {
    let currentPointer = design_tokens_tokens_json_1.default;
    const pathSegments = path.split(".").reverse();
    let result = fallbackValue;
    while (pathSegments.length) {
        const segment = pathSegments.pop();
        if (segment !== undefined &&
            currentPointer.hasOwnProperty(segment) &&
            currentPointer[segment]) {
            currentPointer = currentPointer[segment];
        }
    }
    if (currentPointer.hasOwnProperty("value")) {
        result = currentPointer.value;
    }
    else if (fallbackValue) {
        console.warn(`Token value of ${path} is not found in json data file, returning fallback value: ${fallbackValue}`);
    }
    else {
        console.error(`Token value of ${path} is not found in json data file, and fallbackValue is not provided`);
    }
    return result;
};
exports.getDesignToken = getDesignToken;
//# sourceMappingURL=getDesignToken.js.map